import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppSyncHelper } from '../helpers';
import { GradeModel } from '../models';
import { GET_GRADES } from '../resolvers';

@Injectable({ providedIn: 'root' })
export class GradeService {
  constructor(public appSyncHelper: AppSyncHelper) {}

  public getGrades(): Observable<GradeModel[]> {
    return this.appSyncHelper.queryViaApiKeyAuth(GET_GRADES, {}).pipe(
      map((response: { getGrades: GradeModel[] }) => response.getGrades));
  }
}
